import Hero from "@/components/landing/Hero";
import Experience from "@/components/landing/Experience";
import Projects from "@/components/landing/Projects";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import Nav from "@/components/landing/Nav";

export default function Landing() {
  return (
    <main
      data-testid="landing-page"
      className="relative min-h-screen bg-black text-[#F2F2F2] font-sans grain"
    >
      <Nav />
      <Hero />
      <Experience />
      <Projects />
      <Contact />
      <Footer />
    </main>
  );
}
